import { EmployeeProfileGradeSystemSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/gradeSystem/employeeProfile.gradeSystem.translation.pl.ts';

export const employeeProfileGradeSystemSectionTranslation: EmployeeProfileGradeSystemSectionTranslation =
  {
    content: {
      finalGrade: 'Final Grade',
      potentialGrade: 'Potential',
      qualitativeGrade: 'Qualitative Grade',
      quantitativeGrade: 'Quantitative Grade',
      sectionTitle: 'Annual Assessment Result',
    },
    headerTitle: 'Grade System',
    headerTitleShorter: 'Grade System',
  };
